import { render } from "./EventAddDialog.vue?vue&type=template&id=116ddc9e"
import script from "./EventAddDialog.vue?vue&type=script&lang=js"
export * from "./EventAddDialog.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__